import React from 'react';
import './LinhaDigitavel.scss';

export default function LinhaDigitavel() {

    function onChange(ev) {
        const target = ev.target;
        if (target.value.length === target.maxLength) {
            if (target.nextSibling) {
                target.nextSibling.focus();
            }
        }
    }

    function onKeyDown(ev) {
        if (!(/^[0-9]*$/.test(ev.key)) && ev.key !== 'Backspace') {
            ev.preventDefault();
        }
    }

    // TODO: feature: delete and back to prev field
    // TODO: feature: accept shift + tab, tab, select with shift and others...
    return (
        <div className="linha-digitavel">
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 100 }} maxLength={5} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 100 }} maxLength={5} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 100 }} maxLength={5} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 120 }} maxLength={6} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 100 }} maxLength={5} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 100 }} maxLength={6} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 40 }} maxLength={1} />
            <input onChange={onChange} onKeyDown={onKeyDown} type="text" style={{ width: 220 }} maxLength={14} />
        </div>
    )
}
